import {
  createReusableStylesheet,
  type ReusableStylesheet,
} from '@trimble/stylesheets';
import modusStyles from '@trimble-oss/moduswebcomponents/modus-wc-styles.css?inline';
import styles from '../styles.css?inline';

export const web3dWebComponentsStylesheet = createReusableStylesheet(
  'web3d-web-components:styles',
  styles
);
export const web3dWebComponentsModusStylesheet = createReusableStylesheet(
  'web3d-web-components:modus-styles',
  modusStyles
);

export const web3dWebComponentsStylesheets: readonly ReusableStylesheet[] = [
  web3dWebComponentsStylesheet,
];

export const web3dWebComponentsWithModusStylesheets: readonly ReusableStylesheet[] =
  [web3dWebComponentsStylesheet, web3dWebComponentsModusStylesheet];
